"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewMfaSecret extends new_item_1.default {
    constructor(newMfaSecret) {
        super();
        this.secretUrl = newMfaSecret.secretUrl;
    }
}
exports.default = NewMfaSecret;
//# sourceMappingURL=new-mfaSecret.js.map